export default "__VITE_ASSET__BVIQG9TD__"